import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import FieldSelectWithOther from './FieldSelectWithOther.jsx';
import FieldTextBox from './FieldTextBox.jsx';
import FieldTextArea from './FieldTextArea.jsx';
import FieldDate from './FieldDate.jsx';
import DirtDetails from './DirtDetails.jsx';
import DirtReflection from './DirtReflection.jsx';
import FieldRatingSelfSubmit from './FieldRatingSelfSubmit.jsx';
import { fetchDrivers } from '../../actions/driver';
import { fetchSeries } from '../../actions/series';
import { fetchTracks } from '../../actions/track';

export class Dirt extends React.Component {
  componentDidMount() {
    this.props.fetchDrivers();
    this.props.fetchSeries({ raceSurface: 'dirt' });
    this.props.fetchTracks({ raceSurface: 'Dirt' });
  }

  render() {
    const { drivers, series, tracks } = this.props;

    return (
      <form id="self-ratings-dirt-form" autoComplete="off">
        <h3>TRD Driver Self Rating - Dirt</h3>
        <Row>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={drivers}
              defaultEmptyOption="Driver Name *"
              field="driverName"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={series}
              defaultEmptyOption="Series *"
              field="series"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={tracks}
              defaultEmptyOption="Track *"
              field="track"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={3}>
            <FieldTextBox placeholder="Start Position" field="start" />
          </Col>
          <Col xs={12} sm={3}>
            <FieldTextBox placeholder="End Position" field="end" />
          </Col>
          <Col xs={12} sm={3}>
            <FieldTextBox placeholder="Team Name" field="teamName" />
          </Col>
          <Col xs={12} sm={3}>
            <FieldDate />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h6 style={{ marginBottom: '5px' }}>
                Track Notes
              <small>
                <br />
                  (Track condition, lines, groove, etc.)
              </small>
            </h6>
            <FieldTextArea placeholder="Feedback" field="trackCharacteristics" />
          </Col>
        </Row>
        <DirtDetails />
        <DirtReflection />

        <div className="form-submit-wrapper">
          <div className="pull-right">
            <FieldRatingSelfSubmit formType="dirt" />
          </div>
        </div>
      </form>
    );
  }
}

export const mapStateToProps = state => ({
  drivers: state.driver.result,
  series: state.series.result,
  tracks: state.track.result,
});

export default connect(
  mapStateToProps,
  { fetchDrivers, fetchSeries, fetchTracks },
)(Dirt);
